module.exports = "<div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12 ctabtn\">\r\n  <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 bg-white text-center\">\r\n    <a routerLink=\"/login\" class=\"btn bgRed\">JOIN NOW</a>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/genericpages/applynow.component.html
// module id = ./src/app/genericpages/applynow.component.html
// module chunks = main